import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { Header, Footer, SkipNavLink } from 'components'
import { PATH } from 'config'
import { scrollToTop } from 'utils'

const propTypes = {
  children: PropTypes.node.isRequired,
}

function UnauthenticatedLayout({ children }) {
  const { pathname } = useLocation()

  // Scroll to top of page when route changes
  useEffect(() => {
    scrollToTop()
  }, [pathname])

  return (
    <div>
      <SkipNavLink targetId="main-content">Skip to main content</SkipNavLink>
      <Header logoLink={PATH.SEATOW} />
      <main id="main-content">{children}</main>
      <Footer />
    </div>
  )
}

UnauthenticatedLayout.propTypes = propTypes

function mapStateToProps() {
  return {}
}

const mapDispatchToProps = {}

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  UnauthenticatedLayout
)
